import type { RouteRecordRaw } from 'vue-router'

import StationBoardLayout from '@/modules/absence/layouts/StationBoardLayout.vue'

export const ABSENCE = 'absence'
export const STATION_BOARD = 'station-board'

export default [
  {
    path: '/absence',
    name: ABSENCE,
    component: () => import('./views/Absence.vue'),
    meta: {
      auth: true,
      nativeOnly: true,
    },
  },
  {
    path: '/station-board',
    name: STATION_BOARD,
    component: () => import('./views/StationBoard.vue'),
    meta: {
      layout: StationBoardLayout,
    },
  },
] as RouteRecordRaw[]
